import bottomMode from "../../../../lib/assets/dt-bottom-mode.svg";
import leftMode from "../../../../lib/assets/dt-left-mode.svg";
import rightMode from "../../../../lib/assets/dt-right-mode.svg";
import seperateMode from "../../../../lib/assets/dt-seperate-mode.svg";
import captureIcon from "../../../../lib/assets/captureIcon.svg";
export default {
  bottomMode,
  leftMode,
  rightMode,
  seperateMode,
  captureIcon
};
//# sourceMappingURL=icons.js.map
